// extracted by mini-css-extract-plugin
export default {"card":"KeyPointCard_card__BOGle","cardWrapper":"KeyPointCard_cardWrapper__gIvxV","cardText":"KeyPointCard_cardText__Cdx2A"};